//@ts-ignore
import axios from "axios";
import { Progress } from "rsup-progress";
import { apiErrorLog } from "src/api/logger"
import {
  API_BASE_URL,
  API_BASE_URL_NO_PREFIX,
  API_BASE_URL_V2,
  API_MAILING_BASE_URL,
  API_OPEN_BASE_URL
} from "src/config"
import { appLocalStorage } from "src/libs";

const progress = new Progress({
  height: 3,
  color: "#62bb46",
})

const api = axios.create({
  baseURL: `${API_BASE_URL}`,
})

api.interceptors.request.use(function (config) {
  const token = appLocalStorage.token
  config.headers["Authorization"] = `Bearer ${token}`;
  config.headers["X-Requested-With"] = "XMLHttpRequest";

  if (config.useV2Api) {
    config.baseURL = API_BASE_URL_V2;
  }

  if (config.prefix) {
    config.baseURL = `${API_BASE_URL_NO_PREFIX}${config.prefix}/`;
  }

  if (config.useOpenRoutes) {
    config.baseURL = API_OPEN_BASE_URL;
  }

  if (config.useMailingApi) {
    config.baseURL = API_MAILING_BASE_URL;
    config.headers["X-Api-Key"] = token;
  }

  return config;
}, function (error) {
  return Promise.reject(error);
});

api.interceptors.response.use(

  async (res) => {
    const response = await progress.promise(res)
    return res.data
  },
  async (error) => {
    // Пробрасываем РЕАЛЬНУЮ ошибку axios, чтобы у вызывающего кода был доступ к
    // error.response.data.message (причина от бэка/банка) и статусу. Раньше здесь
    // стоял отладочный `throw Error("error: ")`, из-за которого весь разбор ошибки
    // ниже был недостижим, а в UI никогда не доходила причина ошибки.
    if (error.response?.status !== 401) {
      apiErrorLog(error)
    }
    throw error
  },
)

export default api
